import React from "react"
import {CurrencyConfiguration} from "@next/utils"
import FacetListLabelWrapper from "../../../horizontalFilters/facetListBox/facetListLabelWrapper"
import FacetListSelectLabel from "../../../horizontalFilters/facetListBox/facetListSelectLabel"
import {SELECT_RANGE} from "../../../../config/constants"
import FacetsPrice from "../../../facetsPrice"

export interface StandardFacetsPriceSelectorProps {
    name: string
    isTabbedFilter?: boolean
    globalPriceFormattingConfig: CurrencyConfiguration
}

export const StandardFacetsPriceSelector = ({
    name,
    isTabbedFilter,
    globalPriceFormattingConfig,
}: StandardFacetsPriceSelectorProps) => {
    return (
        <div>
            {/* this is to hide `SELECT_RANGE` text on mobile  */}
            {!isTabbedFilter && (
                <FacetListLabelWrapper>
                    <FacetListSelectLabel>
                        <span>{SELECT_RANGE}</span>
                    </FacetListSelectLabel>
                </FacetListLabelWrapper>
            )}
            <FacetsPrice
                name={name}
                isTabbedFilter={isTabbedFilter}
                globalPriceFormattingConfig={globalPriceFormattingConfig}
            />
        </div>
    )
}

export default StandardFacetsPriceSelector
